<template>
  <section
    :class="{
      'empty-state-container': true,
      'empty-state-container--noBorder': noBorder,
      'empty-state-container--small': size === 'small',
      'empty-state-container--xsmall': size === 'xsmall'
    }"
    :style="alignment"
  >
    <slot name="image">
      <img v-if="image" :src="image" alt="empty" />
    </slot>
    <aside>
      <WTitle v-if="title" class="state-title" size="xsmall">{{
        title
      }}</WTitle>
      <WParagraph v-if="message" class="state-message">{{
        message
      }}</WParagraph>
      <slot></slot>
    </aside>
  </section>
</template>

<script>
import { WParagraph, WTitle } from '@alice-health/wonderland-vue'

export default {
  components: { WTitle, WParagraph },
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    noBorder: Boolean,
    size: {
      type: String,
      default: 'small'
    },
    icon: {
      type: String,
      default: 'wind'
    },
    alignTo: {
      type: String,
      default: 'center',
      validator: value => {
        return ['center', 'flex-start', 'flex-end'].includes(value)
      }
    }
  },
  data() {
    return {
      image: ''
    }
  },
  computed: {
    alignment() {
      return { alignItems: this.alignTo }
    }
  },
  watch: {
    icon: {
      handler: 'importImage',
      immediate: true
    }
  },
  methods: {
    async importImage() {
      const { default: image } = await import(`@/assets/${this.icon}.svg`)
      this.image = image
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.empty-state-container {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--gl-spacing-10);
  padding: var(--gl-spacing-10);
  color: var(--sys-color-content-secondary);
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  border-radius: var(--gl-border-radius-md);
  align-items: center;

  &--noBorder {
    border: 0;
  }

  &--small {
    gap: var(--gl-spacing-06);
    padding: var(--gl-spacing-06);

    img {
      width: 96px;
    }
  }

  &--xsmall {
    gap: var(--gl-spacing-04);
    padding: var(--gl-spacing-04);
    background: var(--sys-color-surface-background-light);
    color: var(--sys-color-content-primary);
    border: 0;

    .state-title {
      @extend %body-default;
      font-weight: 500;
    }

    img {
      width: 96px;
    }
  }
}

.state-title {
  @extend %title-small;
  margin-bottom: 0;

  + .message {
    margin-top: var(--gl-spacing-06);
  }
}

.state-message {
  @extend %body-small;
  margin-bottom: 0;
}
</style>
